import InfoRow from './InfoRow.view';

export default InfoRow;
